import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/core/base.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { GlobalDataService } from 'src/app/shared/services/global-data.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { PrizeService } from '../prize.service';

@Component({
    selector: 'app-prize-create',
    templateUrl: './prize-create.component.html',
    styleUrls: ['./prize-create.component.scss'],
    standalone: false
})

export class PrizeCreateComponent extends BaseComponent implements OnInit, AfterViewInit {
  public form = new FormGroup({
    name: new FormControl('',{
      validators: Validators.required
    }),
    description: new FormControl('',{
      validators: Validators.required
    }),
    value: new FormControl('',{
      validators: Validators.required
    }),
    expenseCost: new FormControl(),
    outingIterationId: new FormControl('',{
      validators: Validators.required
    }),
    createdBy: new FormControl(),
  });

  public canCreatePrize: boolean = true;

  constructor(public sessionService: SessionService,
    private prizeService: PrizeService,
    private router: Router,
    private globalDataService: GlobalDataService,
    stringHelpers: StringHelpers) {
    super(sessionService, stringHelpers);
   }

  ngOnInit(): void {
    this.selectedIteration = this.getGlobalOutingIteration();
    this.form.get('outingIterationId').setValue(this.selectedIteration.id);
  }

  ngAfterViewInit(): void {
    this.globalDataService.iterationSelectionEvent.subscribe(result => {
      this.selectedIteration = result;
      this.canCreatePrize = true;
    });
  }

  onSubmit({value, valid}){
    if(valid){
      this.isLoading = true;
      value.createdBy = this.sessionService.getUserId();
      this.prizeService.create(value).subscribe(results => {
        this.isLoading = false;
        this.router.navigate(['outing-management', 'administration', 'prize', 'details', results.id]);
      },(err: any) => {
        this.isLoading = false;
        this.setError(err, this.form);
      });
    }
  }

}
